function swiperSlide() {
  let sliderList = document.querySelectorAll("div.homepage_featured-products-list");
  sliderList.forEach(slide => {
    let numberSlide = (parseInt(slide.getAttribute('data-number')));
    const initialSlide = (numberSlide % 2 == 0) ? (numberSlide / 2 - 1) : (numberSlide / 2 + 0.5);
    const swiper = new Swiper(slide, {
      slidesPerView: 4,
      spaceBetween: 20,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.5,
          spaceBetween: 0,
          initialSlide: initialSlide,
          centeredSlides: true,
          draggable: true,
          loop: true
        },
        768: {
          slidesPerView: 4,
          centeredSlides: false,
          draggable: false,
          loop: false,
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
          }
        }
      }
    })
  });
}
swiperSlide();
class StickyATC extends HTMLElement {
  constructor() {
    super();
    let idSelector = `#${document.querySelector(".c-product-info__form").getAttribute("id")}`;
    if (window.innerWidth < 799) {
      this.querySelector("button").addEventListener('click', () => this.onButtonClick(document.querySelector(idSelector)));
    }
  }
  onButtonClick(element) {
    var atc_button = theme.atc_state_manager.$atc_button[0]; 
    if(atc_button.classList.contains("disabled") || atc_button.style.display === 'none'){
      element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    } else {
      atc_button.click();
    }
  }
}
customElements.define('sticky-atc', StickyATC);